import { functions } from './firebase';
const sendSlackMessageFirebase = functions.httpsCallable('slack-sendMessage');
export const postMessage = async (message: string): Promise<void> => {
  if (process.env.REACT_APP_ENV === 'prod') {
    await sendSlackMessageFirebase(message);
  } else {
    console.log('Message envoyé sur Slack => ', message);
  }
};
